<script setup>
import { inject, onMounted, ref, onBeforeMount } from 'vue';
import { useRouter } from 'vue-router';
import { useMainStore } from '../store';
import ContactDetails from '../components/ContactDetails.vue';

const router = useRouter();
// const adobeEvent = inject('adobeEvent');
const store = useMainStore();

const noOffersAvailable = ref(false);
const errorLoadingOffers = ref(false);
const notAllowedToSeeOffer = ref(false);
const isError = ref(false);

onBeforeMount(() => {
  store.activePage = 'HOME';
});

onMounted(() => {
  isError.value = false;
  // adobeEvent({
  //   event: 'pageView',
  //   page: {
  //     pageName: 'PublicHomeView',
  //     offerId: store.offerId,
  //     regulationsApproved: store.getOfferStatus?.status.regulationsApprovedForUser,
  //     error: {
  //       isErrorPage: isError.value,
  //       data: {
  //         noOffersAvailable: noOffersAvailable.value,
  //         notAllowedToSeeOffer: notAllowedToSeeOffer.value,
  //         errorLoadingOffers: errorLoadingOffers.value,
  //       },
  //     },
  //   },
  // });
});
// const checkError = () => {
//   if(!store.offerId) {
//     noOffersAvailable.value = true;
//     return true;
//   }
//   if(store.offerId) {
//     notAllowedToSeeOffer.value = true;
//     return true;
//   }

//   router.push({ name: 'PublicConfiguratorView', query: { id: store.offerId }});
// };

</script>
<template>
  <section>
    <template v-if="notAllowedToSeeOffer">
      <h1>{{ $i18n('roadClosed') }}</h1>
      <p>{{ $i18n('restrictedAccess') }}</p>
      <a
        href="https://my.scania.com"
        class="sdds-btn sdds-btn-primary"
        data-dd-action-name="go to my scania"
      >
        {{ $i18n('goToMyScania') }}
      </a>
    </template>
    <template v-if="noOffersAvailable">
      <h1>{{ $i18n('noActiveOffers') }}</h1>
      <p>{{ $i18n('noActiveOffersText') }}</p>
      <a
        href="https://my.scania.com"
        class="sdds-btn sdds-btn-primary"
        data-dd-action-name="go to my scania"
      >
        {{ $i18n('goToMyScania') }}
      </a>
    </template>
    <!-- <template v-if="offerExpired">
      <h1>{{ $i18n('offerExpired') }}</h1>
      <p>{{ $i18n('offerExpiredText') }}</p>
      <ContactDetails />
    </template> -->
    <template v-if="errorLoadingOffers">
      <h1>{{ $i18n('error') }}</h1>
      <p>{{ $i18n('errorLoadingOffer') }}</p>
      <a
        href="https://buy.scania.com"
        class="sdds-btn sdds-btn-primary"
        data-dd-action-name="try again"
      >
        {{ $i18n('tryAgain') }}
      </a>
    </template>
  </section>
</template>

<style scoped>
  section {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2em;
  }
  @media only screen and (max-width: 500px) {
    section {
      padding: 1em;
    }
  }
</style>
